import { Controller } from "@hotwired/stimulus"
import debounce from "lodash.debounce"

const DEBOUNCE_TIMING = 200

export default class extends Controller {
  connect() {
    this.submit = debounce(this.#submitForm.bind(this), DEBOUNCE_TIMING)
  }

  #submitForm() {
    this.element.requestSubmit()
  }
}
